/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Status = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;
export type Status = typeof Status[keyof typeof Status];


// @ts-ignore
export function StatusFromJSON(json: any): Status {
    return StatusFromJSONTyped(json, false);
}

// @ts-ignore
export function StatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): Status {
    return json as Status;
}

// @ts-ignore
export function StatusToJSON(value?: Status | null): any {
    return value as any;
}

